<template>
  <div class="foot">
    <div class="foot_con">
      <div class="title">
        <div>地点：广东省珠海市香洲区翠峰路189号珠海报业新媒体大厦11F</div>
        <div>电话：0756-2299919</div>
        <div>邮箱：2518397520@qq.com</div>
      </div>
      <div class="copy">
        ©2005-2021 珠海城视在线网络科技有限公司 版权所有，并保留所有权利
      </div>
    </div>
  </div>
</template>
<script>
export default {

}
</script>
<style lang="scss" scoped>
.foot {
  height: 136px;
  background: #EAEAEA;
  display: flex;
  justify-content: center;
  .foot_con {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 1200px;
    .copy{
       color: #666666;
    }
    .title {
      display: flex;
      justify-content: center;
      color: #666666;
      div {
        padding: 0 20px;
        margin: 0 0 16px 0;
      }
    }
  }
}
</style>
